import { BodyMD } from "../../../typography";
import { Link } from "react-router-dom";
import { legalLinks } from "../config/footerConfig";

export const FooterBottom = () => {
  return (
    <div className="tw-flex tw-w-full tw-flex-col tw-flex-wrap tw-justify-between tw-gap-[1em] min440:tw-flex-row">
      <BodyMD className="tw-text-white tw-text-opacity-60">
        © 2025 Verse Medical.
      </BodyMD>

      <div className="tw-z-20 tw-flex tw-gap-x-[24px]">
        {legalLinks.map((link) => (
          <Link key={link.title} to={link.href} className="tw-no-underline">
            <BodyMD className="tw-mb-0 tw-text-white tw-text-opacity-60 hover:tw-underline">
              {link.title}
            </BodyMD>
          </Link>
        ))}
      </div>
    </div>
  );
};
